var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiStarsFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4931_342)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 0C15.3014 0 15.5654 0.202271 15.6437 0.493345L15.8519 1.26645C16.099 2.18418 16.8158 2.90103 17.7336 3.14813L18.5067 3.35629C18.7977 3.43466 19 3.69859 19 4.00003C19 4.30147 18.7977 4.56541 18.5067 4.64378L17.7336 4.85194C16.8158 5.09903 16.099 5.81589 15.8519 6.73361L15.6437 7.50672C15.5654 7.7978 15.3014 8.00007 15 8.00007C14.6986 8.00007 14.4346 7.7978 14.3563 7.50672L14.1481 6.73361C13.901 5.81589 13.1842 5.09903 12.2664 4.85194L11.4933 4.64378C11.2023 4.56541 11 4.30147 11 4.00003C11 3.69859 11.2023 3.43466 11.4933 3.35629L12.2664 3.14813C13.1842 2.90103 13.901 2.18418 14.1481 1.26645L14.3563 0.493345C14.4346 0.202271 14.6986 0 15 0ZM17 14C17.2261 14 17.424 14.1517 17.4828 14.37L17.6389 14.9498C17.8242 15.6381 18.3619 16.1758 19.0502 16.3611L19.63 16.5172C19.8483 16.576 20 16.7739 20 17C20 17.2261 19.8483 17.4241 19.63 17.4828L19.0502 17.639C18.3619 17.8243 17.8242 18.3619 17.6389 19.0502L17.4828 19.63C17.424 19.8483 17.2261 20.0001 17 20.0001C16.7739 20.0001 16.576 19.8483 16.5172 19.63L16.3611 19.0502C16.1758 18.3619 15.6381 17.8243 14.9498 17.639L14.37 17.4828C14.1517 17.4241 14 17.2261 14 17C14 16.7739 14.1517 16.576 14.37 16.5172L14.9498 16.3611C15.6381 16.1758 16.1758 15.6381 16.3611 14.9498L16.5172 14.37C16.576 14.1517 16.7739 14 17 14ZM7.82059 6.11501C7.58079 5.29503 6.4192 5.29504 6.1794 6.11502L5.60039 8.09489C5.17668 9.54374 4.04371 10.6767 2.59486 11.1004L0.614985 11.6794C-0.205002 11.9192 -0.204988 13.0808 0.614986 13.3206L2.59486 13.8996C4.04372 14.3233 5.17668 15.4563 5.60039 16.9051L6.1794 18.885C6.4192 19.705 7.58079 19.705 7.82059 18.885L8.3996 16.9051C8.82332 15.4563 9.95628 14.3233 11.4051 13.8996L13.385 13.3206C14.205 13.0808 14.205 11.9192 13.385 11.6794L11.4051 11.1004C9.95628 10.6767 8.82332 9.54374 8.3996 8.09488L7.82059 6.11501Z",
    fill: "url(#paint0_linear_4931_342)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4931_342",
    x1: 20,
    y1: 0,
    x2: -0.0000514983,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FACC15"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#06B6D4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4931_342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiStarsFilled);
export default __webpack_public_path__ + "static/media/ai-stars-filled.7d90f5d487d00cfdb82b91feceddd95d.svg";
export { ForwardRef as ReactComponent };